// Facebook Pixel helper — safe no-op if pixel blocked or not loaded.
// Also forwards events to backend for Conversion API (server-side).

import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function fbq(...args) {
  try {
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq(...args);
    }
  } catch (e) { /* silent */ }
}

async function serverEvent(name, data = {}, userData = {}) {
  try {
    await axios.post(`${API}/fb-events`, {
      event_name: name,
      event_id: data.event_id || `${name}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      event_source_url: typeof window !== 'undefined' ? window.location.href : '',
      custom_data: data,
      user_data: userData,
    }, { timeout: 8000 }).catch(() => {});
  } catch (e) { /* silent */ }
}

export const fbTrack = {
  pageView: () => fbq('track', 'PageView'),

  viewContent: (contentName = 'Packages', value = 0) => {
    const eventId = `vc_${Date.now()}`;
    fbq('track', 'ViewContent', { content_name: contentName, value, currency: 'INR' }, { eventID: eventId });
    serverEvent('ViewContent', { event_id: eventId, content_name: contentName, value, currency: 'INR' });
  },

  initiateCheckout: (packageId = '', value = 0) => {
    const eventId = `ic_${Date.now()}`;
    fbq('track', 'InitiateCheckout', {
      content_ids: [packageId],
      content_type: 'product',
      value, currency: 'INR',
    }, { eventID: eventId });
    serverEvent('InitiateCheckout', { event_id: eventId, content_ids: [packageId], value, currency: 'INR' });
  },

  lead: (bookingData = {}) => {
    const eventId = `ld_${bookingData.id || Date.now()}`;
    const value = bookingData.amount || 0;
    fbq('track', 'Lead', {
      content_name: bookingData.package_name || '',
      content_category: bookingData.package_id || '',
      value, currency: 'INR',
    }, { eventID: eventId });
    serverEvent('Lead', {
      event_id: eventId,
      content_name: bookingData.package_name || '',
      content_category: bookingData.package_id || '',
      value, currency: 'INR',
      booking_id: bookingData.id,
    }, {
      phone: bookingData.mobile,
      first_name: bookingData.name,
    });
  },

  purchase: (bookingData = {}) => {
    const eventId = `pu_${bookingData.id || Date.now()}`;
    const value = bookingData.amount || 0;
    fbq('track', 'Purchase', {
      content_ids: [bookingData.package_id],
      content_name: bookingData.package_name || '',
      content_type: 'product',
      value, currency: 'INR',
      num_items: 1,
    }, { eventID: eventId });
    serverEvent('Purchase', {
      event_id: eventId,
      content_ids: [bookingData.package_id],
      content_name: bookingData.package_name || '',
      value, currency: 'INR',
      booking_id: bookingData.id,
    }, {
      phone: bookingData.mobile,
      first_name: bookingData.name,
    });
  },
};

export default fbTrack;
